import Vue from 'vue'
import TIM from 'tim-js-sdk';
import COS from "cos-js-sdk-v5";
let appId = process.env.NODE_ENV == 'production' ? 1400525598 : 1400534984;
let logId =  process.env.NODE_ENV == 'production' ? 1 : 0;
let options = {
    SDKAppID: appId// 接入时需要将0替换为您的即时通信 IM 应用的 SDKAppID process.env.NODE_ENV==='production'?'1400525598':'1400534984',
};
// 创建 SDK 实例，`TIM.create()`方法对于同一个 `SDKAppID` 只会返回同一份实例
let tim = TIM.create(options); // SDK 实例通常用 tim 表示
// 设置 SDK 日志输出级别，详细分级请参见 setLogLevel 接口的说明
tim.setLogLevel(logId); // 普通级别，日志量较多，接入时建议使用
// tim.setLogLevel(1); // release 级别，SDK 输出关键信息，生产环境时建议使用
// 注册 COS SDK 插件
tim.registerPlugin({ 'cos-js-sdk': COS });
// 监听事件，例如：
tim.on(TIM.EVENT.SDK_READY, function (event) {
    // //console.log('event=======>', event)
    // 收到离线消息和会话列表同步完毕通知，接入侧可以调用 sendMessage 等需要鉴权的接口
    // event.name - TIM.EVENT.SDK_READY
});

tim.on(TIM.EVENT.MESSAGE_RECEIVED, function (event) {
    //console.log('收到消息')
    // 若同时收到多个会话 需要根据conversationID来判断是哪个人的会话
    var msgarr = []
    var newMsgForm = event.data[0].conversationID // 定义会话键值
    // //console.log(msgarr[newMsgForm])
    if (msgarr[newMsgForm]) {
        msgarr[newMsgForm].push(event.data[0])
    } else {
        msgarr[newMsgForm] = [event.data[0]]
    }
    // //console.log(msgarr[newMsgForm])
    // 这里引入了一个监听器 （因为小程序没有类似vuex的状态管理器 当global里面的数据变化时不能及时同步到聊天页面 因此 这个监听器可以emit一个方法 到需要更新会话数据的页面 在那里进行赋值）
    // 未读消息数
    // 根据isRead判断是否未读 否则加1
    if (!event.data[0].isRead) {
        number = number++
    }
    //console.log(number)
    // 收到推送的单聊、群聊、群提示、群系统通知的新消息，可通过遍历 event.data 获取消息列表数据并渲染到页面
    // event.name - TIM.EVENT.MESSAGE_RECEIVED
    // event.data - 存储 Message 对象的数组 - [Message]
})

tim.on(TIM.EVENT.MESSAGE_REVOKED, function (event) {
    // 收到消息被撤回的通知
    // event.name - TIM.EVENT.MESSAGE_REVOKED
    // event.data - 存储 Message 对象的数组 - [Message] - 每个 Message 对象的 isRevoked 属性值为 true
});

tim.on(TIM.EVENT.CONVERSATION_LIST_UPDATED, function (event) {
    // 更新当前所有会话列表
    // 注意 这个函数在首次点击进入会话列表的时候也会执行 因此点击消息 可以显示当前的未读消息数（unreadCount表示未读数）
    //console.log('发送了消息')
    //console.log('更新当前所有会话列表')
    var conversationList = event.data
    var number = 0
    conversationList.forEach(e => {
        number = number + e.unreadCount
    })
    // 收到会话列表更新通知，可通过遍历 event.data 获取会话列表数据并渲染到页面
    // event.name - TIM.EVENT.CONVERSATION_LIST_UPDATED
    // event.data - 存储 Conversation 对象的数组 - [Conversation]
});

tim.on(TIM.EVENT.GROUP_LIST_UPDATED, function (event) {
    // 收到群组列表更新通知，可通过遍历 event.data 获取群组列表数据并渲染到页面
    // event.name - TIM.EVENT.GROUP_LIST_UPDATED
    // event.data - 存储 Group 对象的数组 - [Group]
});

tim.on(TIM.EVENT.GROUP_SYSTEM_NOTICE_RECEIVED, function (event) {
    // 收到新的群系统通知
    // event.name - TIM.EVENT.GROUP_SYSTEM_NOTICE_RECEIVED
    // event.data.type - 群系统通知的类型，详情请参见 GroupSystemNoticePayload 的 operationType 枚举值说明
    // event.data.message - Message 对象，可将 event.data.message.content 渲染到到页面
});

tim.on(TIM.EVENT.PROFILE_UPDATED, function (event) {
    // 收到自己或好友的资料变更通知
    // event.name - TIM.EVENT.PROFILE_UPDATED
    // event.data - 存储 Profile 对象的数组 - [Profile]
});

tim.on(TIM.EVENT.BLACKLIST_UPDATED, function (event) {
    // 收到黑名单列表更新通知
    // event.name - TIM.EVENT.BLACKLIST_UPDATED
    // event.data - 存储 userID 的数组 - [userID]
});

tim.on(TIM.EVENT.ERROR, function (event) {
    // 收到 SDK 发生错误通知，可以获取错误码和错误信息
    // event.name - TIM.EVENT.ERROR
    // event.data.code - 错误码
    // event.data.message - 错误信息
});

tim.on(TIM.EVENT.SDK_NOT_READY, function (event) {
    //console.log('SDK_NOT_READY')
    // 收到 SDK 进入 not ready 状态通知，此时 SDK 无法正常工作
    // event.name - TIM.EVENT.SDK_NOT_READY
});

tim.on(TIM.EVENT.KICKED_OUT, function (event) {
    //console.log('KICKED_OUT')
    // 收到被踢下线通知
    // event.name - TIM.EVENT.KICKED_OUT
    // event.data.type - 被踢下线的原因，例如:
    //    - TIM.TYPES.KICKED_OUT_MULT_ACCOUNT 多实例登录被踢
    //    - TIM.TYPES.KICKED_OUT_MULT_DEVICE 多终端登录被踢
    //    - TIM.TYPES.KICKED_OUT_USERSIG_EXPIRED 签名过期被踢
})
window.tim = tim
window.TIM = TIM
Vue.prototype.tim = tim
Vue.prototype.TIM = TIM
export default tim;